// ABOUTME: Pricing page showing the four hosting tiers (Free, Party Pass, Mega Party, Custom).
// ABOUTME: Paid tiers grant 24 hours of hosting at the purchased player limit.
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router'
import { LandingSection, FeatureCard, PricingTierName } from '../theme'

// Kept in sync manually with bingo-api/src/billing/host-tier.entity.ts
// (TIER_PLAYER_LIMITS and TIER_UPGRADE_PRICES_CENTS).
const TIERS = [
  { name: 'Free',        price: '$0',          limit: 'Up to 8 players',                       cta: null },
  { name: 'Party Pass',  price: '$5',          limit: 'Up to 40 players for 24 hours',         cta: null },
  { name: 'Mega Party',  price: '$10',         limit: 'Up to 200 players for 24 hours',        cta: null },
  { name: 'Custom',      price: "Let's talk",  limit: 'Need more than 200 players, white-label, or custom integration?', cta: { label: 'Contact us', to: '/contact' } },
] as const

export function PricingPage() {
  return (
    <LandingSection>
      <Container maxWidth="lg">
        <Typography variant="h2" component="h1" align="center" gutterBottom>
          Simple, transparent pricing
        </Typography>
        <Typography variant="h6" align="center" color="text.secondary" gutterBottom>
          Buy 24 hours of hosting when you need a bigger crowd. No subscriptions.
        </Typography>
        <Box mt={6}>
          <Grid container spacing={3}>
            {TIERS.map((tier) => (
              <Grid size={{ xs: 12, sm: 6, md: 3 }} key={tier.name}>
                <FeatureCard>
                  <PricingTierName variant="h4" gutterBottom>
                    {tier.name}
                  </PricingTierName>
                  <Typography
                    variant={tier.name === 'Custom' ? 'h6' : 'h3'}
                    color="primary"
                    gutterBottom
                  >
                    {tier.price}
                  </Typography>
                  <Typography color="text.secondary" gutterBottom>
                    {tier.limit}
                  </Typography>
                  {tier.cta && (
                    <Box mt={2}>
                      <Button variant="contained" color="primary" component={Link} to={tier.cta.to}>
                        {tier.cta.label}
                      </Button>
                    </Box>
                  )}
                </FeatureCard>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </LandingSection>
  )
}
